export const Divider = {
  baseStyle: {
    borderBottom: '1px solid',
    borderColor: 'secondary.200',
    marginTop: 6,
    marginBottom: 4,
    opacity: 1,
  },
};
